import { Logger } from './logger.js';

// Exchange Utilities - Environment and capability detection
export class ExchangeUtils {
  static detectCapabilities() {
    const diagnostics = Office.context.mailbox.diagnostics;
    const hostName = diagnostics.hostName;
    const isOnlineExchange = hostName.includes('outlook.office') || hostName.includes('outlook.com');

    const capabilities = {
      hostName,
      isOnlineExchange,
      isOnPremiseExchange: !isOnlineExchange,
      outlookVersion: diagnostics.hostVersion,
      supportsAttachmentDetails: false,
      supportsAttachmentContent: false,
      requirementSets: {}
    };

    try {
      capabilities.requirementSets.mailbox_1_1 = Office.context.requirements.isSetSupported('Mailbox', '1.1');
      capabilities.requirementSets.mailbox_1_3 = Office.context.requirements.isSetSupported('Mailbox', '1.3');
      capabilities.requirementSets.mailbox_1_5 = Office.context.requirements.isSetSupported('Mailbox', '1.5');
      capabilities.requirementSets.mailbox_1_8 = Office.context.requirements.isSetSupported('Mailbox', '1.8');

      capabilities.supportsAttachmentContent = capabilities.requirementSets.mailbox_1_8;
      capabilities.supportsAttachmentDetails = capabilities.requirementSets.mailbox_1_1;
    } catch (error) {
      Logger.warn('Could not detect requirement sets:', error);
    }

    return capabilities;
  }
}


